import { useEffect, useState } from "react";
import { Trash2, MailOpen, Mail } from "lucide-react";
import api from "@/lib/api";
import { toast, Toaster } from "sonner";

export default function AdminMessages() {
  const [items, setItems] = useState([]);

  const load = async () => {
    const { data } = await api.get("/admin/messages");
    setItems(data || []);
  };
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.put(`/admin/messages/${id}/read`);
    load();
  };

  const remove = async (id) => {
    if (!window.confirm("Silinsin mi?")) return;
    await api.delete(`/admin/messages/${id}`);
    toast.success("Silindi");
    load();
  };

  return (
    <div data-testid="admin-messages-page">
      <Toaster position="top-right" />
      <h1 className="heading-font text-3xl text-[#0A2540] mb-8">İletişim Mesajları</h1>
      {items.length === 0 ? (
        <div className="bg-white border border-slate-200 p-12 text-center text-slate-500">Henüz mesaj yok</div>
      ) : (
        <div className="space-y-3">
          {items.map((m) => (
            <div key={m.id} className={`bg-white border ${m.is_read ? "border-slate-200" : "border-[#0066FF]"} p-6`} data-testid={`message-${m.id}`}>
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="heading-font text-lg text-[#0A2540]">{m.name}</span>
                    {!m.is_read && <span className="text-[10px] bg-[#0066FF] text-white px-2 py-0.5 uppercase tracking-wider">Yeni</span>}
                  </div>
                  <div className="text-sm text-slate-500 mb-3">
                    {m.email} {m.phone && `· ${m.phone}`} {m.company && `· ${m.company}`}
                  </div>
                  {m.subject && <div className="text-sm font-semibold text-[#0A2540] mb-2">{m.subject}</div>}
                  <p className="text-sm text-slate-700 whitespace-pre-wrap">{m.message}</p>
                  <div className="text-xs text-slate-400 mt-3">{new Date(m.created_at).toLocaleString("tr-TR")}</div>
                </div>
                <div className="flex flex-col gap-2 text-xs">
                  {!m.is_read && (
                    <button onClick={() => markRead(m.id)} className="text-[#0066FF] hover:underline whitespace-nowrap" data-testid={`message-mark-read-${m.id}`}>
                      <MailOpen size={12} className="inline mr-1" /> Okundu
                    </button>
                  )}
                  <button onClick={() => remove(m.id)} className="text-red-600 hover:underline whitespace-nowrap" data-testid={`message-delete-${m.id}`}>
                    <Trash2 size={12} className="inline mr-1" /> Sil
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
